export default "__VITE_ASSET__a22c9f65__"